module.exports = __webpack_public_path__ + "img/专利信息分析banner.d795d882.png";